import Vue from 'vue'

Vue.filter('moneyFormat', function (value) {
    // Check if the value is numeric
    if (!(!isNaN(parseFloat(value)) && isFinite(value))) {
        return value;
    }

    var parts = value.toString().split("#");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join("#")
})

Vue.filter('fixedNumber', function (value, decimals) {
    return parseFloat(value).toFixed(decimals)
})


// WEBPACK FOOTER //
// ./src/filters/index.js